<template>
  <div class="contents">
    <div :class="fluid ? 'container-fluid px-3 px-md-3 px-xl-4' : 'container'">
      <div v-if="title || $slots.actions" class="row">
        <div class="col-12">
          <div
            class="breadcrumb-main"
            :class="{ 'justify-content-sm-between': $slots.actions, 'breadcrumb-main--compact': fluid }"
          >
            <div class="d-flex flex-wrap breadcrumb-main__wrapper">
              <div class="d-flex align-items-center user-member__title">
                <h4 class="text-capitalize fw-500 breadcrumb-title">{{ title }}</h4>
              </div>
              <p v-if="subtitle" class="page-subtitle w-100">{{ subtitle }}</p>
            </div>
            <div v-if="$slots.actions" class="action-btn action-btn--wrap">
              <slot name="actions" />
            </div>
          </div>
        </div>
      </div>

      <slot name="alert" />

      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'PageLayout',
  props: {
    title: {
      type: String,
      default: '',
    },
    subtitle: {
      type: String,
    },
    fluid: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style scoped>
.breadcrumb-main--compact {
  margin-bottom: 0.75rem;
  flex-wrap: wrap;
  gap: 0.5rem;
}
.action-btn--wrap {
  max-width: 100%;
}
@media (max-width: 1199.98px) {
  .breadcrumb-main--compact .breadcrumb-title {
    font-size: 1.15rem;
  }
}
</style>
